import { useState, React, createContext, useEffect } from 'react';
import { axios, BLOGS } from '../api';
import { sendReqToServer } from '../Hooks/useAxios';
import { useToasts } from '../Components/UI/toast';

const BlogsDetailsContext = createContext();

// Create a Provider component
const BlogsDetailsContextProvider = ({ children }) => {
  const [blogsList, setBlogsList] = useState([]);
  const [notify] = useToasts();

  const getAllBlogs = async () => {
    try {
      const { response, error } = await sendReqToServer({
        axiosInstance: axios,
        url: BLOGS.getAll,
        method: 'GET',
        requestConfig: {},
      });
      if (response.body.blog.length === 0) {
        notify({
          type: 'WARNING',
          message: 'No Notes Uploaded',
        });
      } else {
        setBlogsList(response.body.blog);
      }
    } catch {
      notify({
        type: 'ERROR',
        message: 'Problem occured while fetching Notes',
      });
    }
  };

  useEffect(() => {
    getAllBlogs();
  }, []);

  const contextValue = {
    blogsList,
    setBlogsList,
    getAllBlogs,
  };

  return (
    <BlogsDetailsContext.Provider value={contextValue}>{children}</BlogsDetailsContext.Provider>
  );
};

export { BlogsDetailsContextProvider, BlogsDetailsContext };
